import type { InterventionsListBreadcrumbProps } from "./interventions-list-breadcrumb.type";
import type { BreadcrumbItem } from "@/modules/breadcrumb";

import Breadcrumb from "@/modules/breadcrumb";
import { useModelLink } from "@/modules/model-link";

const InterventionsListBreadcrumb = ({
  interventions,
}: InterventionsListBreadcrumbProps) => {
  const { getModelLink } = useModelLink();

  const items: BreadcrumbItem[] = interventions.map((intervention) => ({
    title: `${intervention.id}`,
    href: getModelLink("intervention", intervention),
    model: "intervention",
  }));

  return <Breadcrumb items={items} />;
};

export default InterventionsListBreadcrumb;
